import { useState, useEffect, useCallback } from 'react';
import { notificationApi } from '../api/services';

export function useNotifications(pollInterval = 30000) {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetch = useCallback(async () => {
    try {
      const res = await notificationApi.list({ limit: 20, unreadOnly: false });
      setNotifications(res.data.notifications || []);
      setUnreadCount(parseInt(res.data.unread, 10) || 0);
    } catch (err) {
      // silent fail
    }
  }, []);

  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, pollInterval);
    return () => clearInterval(interval);
  }, [fetch, pollInterval]);

  const markRead = async (id) => {
    await notificationApi.markRead(id);
    fetch();
  };

  const markAllRead = async () => {
    await notificationApi.markAllRead();
    fetch();
  };

  return { notifications, unreadCount, markRead, markAllRead, refresh: fetch };
}
